import React, { PropTypes, Component } from 'react'
import styles from './styles'
import Button from 'react-toolbox/lib/button'
import misc from 'utils/misc'

export default class WeekControl extends Component {
  static propTypes = {
    onWeekChange: PropTypes.func,
    thisMonday: PropTypes.object,
  };

  constructor (props, context) {
    super(props, context)
    this.onNextWeek = () => this.props.onWeekChange(1)
    this.onLastWeek = () => this.props.onWeekChange(-1)
  }

  render () {
    const { thisMonday } = this.props

    const thisSunday = misc.getSunday(thisMonday)
    const getDateString = day => `${day.year}/${day.month}/${day.date}`

    const startString = `${getDateString(thisMonday)} ~ ${getDateString(thisSunday)}`

    return (
        <div className={styles.weekControl}>
          <Button
            className={styles.timesheetButton}
            icon="navigate-before"
            flat
            onClick={this.onLastWeek}
          />
          <span>{startString}</span>
          <Button
            className={styles.timesheetButton}
            icon="navigate-next"
            flat
            onClick={this.onNextWeek}
          />
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/weekControl/index.jsx